import { render, staticRenderFns } from "./PromoListItemLoader.vue?vue&type=template&id=0c77231c&scoped=true&lang=pug&"
import script from "./PromoListItemLoader.vue?vue&type=script&lang=js&"
export * from "./PromoListItemLoader.vue?vue&type=script&lang=js&"
import style0 from "./PromoListItemLoader.vue?vue&type=style&index=0&id=0c77231c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c77231c",
  null
  
)

export default component.exports